export const FY_CHANNEL = [
  { label: '中信百信银行', value: '01' },
  { label: '福建华通银行', value: '10' },
  { label: '江苏苏商银行', value: '12' }
] as const;

/** 开通方式展示项（isOverSixMonths：1超过6个月 0未超过） */
export const IS_OVER_SIX_MONTHS_OPTIONS = [
  {
    value: 1,
    title: '开通富友支付并开通银行账户',
    desc: '适用于营业期限起满 6 个月的企业，可在开通富友支付时同步开通资金存管银行账户。'
  },
  {
    value: 0,
    title: '仅开通富友支付',
    desc: '根据银行监管要求，营业期限起未满 6 个月的企业暂不支持开通资金存管银行账户。'
  }
] as const;
